import { useState } from "react";

import Modal from "~/components/ui/modal";
import { useLanguage } from "~/contexts/providers/language";

import styles from "./index.module.scss";

type Props = {
  firstName: string;
  lastName: string;
};

const FailedSubscriptionPopup = ({ firstName, lastName }: Props) => {
  const { language } = useLanguage();

  const [modalOpen, setModalOpen] = useState<boolean>(true);

  const handleSetModalClose = () => {
    setModalOpen(false);
  };

  return (
    <Modal open={modalOpen} onClose={handleSetModalClose}>
      <div className={styles.container}>
        <p>
          {language === "En" ? (
            <>
              Hello {firstName} {lastName},
              <br />
              A problem occurred during the payment of your subscription.
              <br />
              Please resolve the issue in order to access our platform.
            </>
          ) : (
            <>
              Bonjour {firstName} {lastName},
              <br />
              Un problème est survenu lors du paiement de votre abonnement.
              <br />
              Merci de mettre à jour votre moyen de paiement pour réactiver
              votre abonnement au Silencio.
            </>
          )}
        </p>
      </div>
    </Modal>
  );
};

export default FailedSubscriptionPopup;
